export const contactsData = [
  { id: 1, title: 'Адрес', icon: 'fas fa-map-marker-alt', content: 'г. Нефтеюганск, микрорайон 13, дом 7, вход за гостинницей "Роял Плаза"' },
  { id: 2, title: 'Телефон', icon: 'fas fa-phone', content: '+7 922 433 47 00' },
  { id: 3, title: 'Email', icon: 'fas fa-envelope', content: 'i7777775@mail.ru' }
];